import { CanActivateFn } from '@angular/router';
import { NewsService } from '../../../../../libs/kfp/src/lib/news/news.service';
import { inject } from '@angular/core';
import { of, switchMap, take } from 'rxjs';
import { ItemResource, UserResource } from '../../../../../libs/kfp/src';
import { KfpStripeService } from '../../../../../libs/kfp/src/lib/utils/stripe/kfpstripe.service';
import { UserService } from '../../../../../libs/kfp/src/lib/users/users.service';

export const ActiveCourseGuard: CanActivateFn = (route, state) => {
    const newsService = inject(NewsService);
    const kfpStripeService = inject(KfpStripeService);
    const userService = inject(UserService);
    let loggedUser: UserResource;
    return userService.user$.pipe(
        take(1),
        switchMap((user: UserResource) => {
            loggedUser = user;
            return newsService.currentEvent$;
        }),
        switchMap((currentEvent: ItemResource | null) => {
            const group = currentEvent.group;
            if (group?.stripeProductName && !group?.linkToSimpleShop) {
                return of(kfpStripeService.checkActiveUserCourse(group?.stripeProductName, loggedUser));
            } else if (group?.linkToSimpleShop) {
                return of(group.users?.some(u => u.id === loggedUser?.id));
            }
            return of(true);
        }),
    );
};
